import { useSelector } from 'react-redux';
import { getAllCountriesOptions } from 'redux/reducers/settings/selectors';

// export const useGetCountryByCode = (countryId: number) => {
// 	const countryList = countries;
// 	const isLoading = false;

// 	// Return null for invalid country IDs
// 	if (!countryId || countryId <= 0) {
// 		return null;
// 	}

// 	if (isLoading) {
// 		return null;
// 	}

// 	// Check if countryList is an array (direct data) or has data property
// 	if (Array.isArray(countryList)) {
// 		const foundCountry = countryList.find((country) => country.code === countryId);
// 		return foundCountry;
// 	}

// 	// If countryList is not an array and not null, it's invalid data
// 	if (!countryList) {
// 		return null;
// 	}

// 	// This should never be reached, but TypeScript needs this for type safety
// 	return null;
// };

export const useGetCountryByISOCode = (isoCode: string) => {
	const countryList = useSelector(getAllCountriesOptions);

	if (!countryList) {
		return null;
	}

	return countryList.find((country) => country.code === isoCode);
};
